<template>
	<div id="app">

		<div class="toast" v-if="header_show" v-show="toastShow">
			{{toastText}}
		</div>
		<header v-if="header_show">
			<div class="nav">
				<div class="logo" @click="nav_active(0,'/')">
					<img src="http://img.anxuan360.com/FmssiHNfuOy07vnmVLTC9jeh0lHZ" alt="">
					<div class="logo_line"></div>
					<div class="nav_intro">
						<span>国家高新技术企业</span><br>
						<span>全栈追溯技术服务商</span>
					</div>
				</div>
				<ul class="navul">
					<li v-for="(item,index) in nav" :class="[item.isactive,item.name=='产品服务'?'chanpin':'']" @click="nav_active(index,item.path)" style="position: relative;">
						<a :href="item.href" style="height: 0;width: 0;display: block;overflow: hidden;">{{item.name}}</a>
						{{item.name}}
						<ul class="chanpinNav">
							<li v-for="(items,index) in chanpinNav" class="clickStyle" @click.stop="navTo(items.path,index)" v-if="item.name=='产品服务'">
								<a :href="items.href" style="height: 0;width: 0;display: block;overflow: hidden;">{{items.name}}</a>
								{{items.name}}
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</header>

		<!--<keep-alive>-->
			<router-view v-on:header="header" v-on:footer="footer" v-on:footer1="footer1" v-on:footer2="footer2" />
		<!--</keep-alive>-->

		<footer style="background-color:#162037;" v-if="footer_show">
			<div class="company_info">
				<div class="company_infoDetail">
					<div class="company_infoDetail_logo"><img src="http://img.anxuan360.com/FoQIVULX9wIZZ6_BrVvJAlkPaUMp" alt=""></div>
					<div class="company_infoDetail_text">地址：浙江省杭州市西湖区西园八路11号一期D座506-507</div>
					<div class="company_infoDetail_text">
            <p style="cursor: pointer" @click="handNavGx">{{ICP_text}}</p>
					</div>
					<div class="company_infoDetail_text">公安部备案号：33010602001517</div>
				</div>
				<div class="company_infoContect">
					<div>
						<div class="company_infoContect_head">联系我们</div>
						<div class="company_infoContect_title">服务热线</div>
						<div class="company_infoContect_text">0571-87357305</div>
						<div class="company_infoContect_title">联系邮箱</div>
						<div class="company_infoContect_text">zjax@ansuw.com</div>
					</div>
					<div style="margin-left: 110px;">
						<p class="guanzhu">微信扫一扫</p>
						<div><img style="width: 101px;height: 101px;" src="http://img.anxuan360.com/FlLk0G-CtUrwGDg4BVr2ic9pqDGU" alt="" /></div>
						<p class="wxHao">微信号:skyline0710</p>
					</div>

				</div>

			</div>
		</footer>

		<div class="sideBar active" v-if="footer1_show">
			<div class="sideBarTitle">联系我们</div>
			<div class="sideBarCall">
				<img src="http://img.anxuan360.com/FmM4Qlii2rF_8treA5bAtyPnjbTL">
				<a href="tel:0571-87357305" style="text-decoration:none;color:#00c59f;">0571-<br>87357305</a>
			</div>
			<div class="sideBarLine"></div>
			<div class="sideBarLine"></div>
			<div class="sideBarTime">
				<img src="http://img.anxuan360.com/FhoCnHsf7eCrOIPvrnt9cvXpPMQj">
				<p>24小时服务</p>
			</div>
			<div class="sideBarLine" :class="!sideBarTotop_show?'noshow':'show'"></div>
			<div class="sideBarTotop" :class="!sideBarTotop_show?'noshow':'show'" @click="gotop">
				<img src="http://img.anxuan360.com/FuxnbUVKdGR17NHtccdvn0FU78Y_">
			</div>
		</div>
		<div class="sideBar" v-if="footer2_show">
			<div class="sideBarTitle">联系我们</div>
			<div class="sideBarCall">
				<img src="http://img.anxuan360.com/FmM4Qlii2rF_8treA5bAtyPnjbTL">
				<a href="tel:0571-87357305" style="text-decoration:none;color:#00c59f;">0571-<br>87357305</a>
			</div>
			<div class="sideBarLine"></div>
			<div style="padding:3px 0;">
				<img style="width:63px;height:63px;display: block;margin: 0 auto;" src="http://img.anxuan360.com/FlLk0G-CtUrwGDg4BVr2ic9pqDGU" alt="" />
				<p style="text-align: center;color: #00C59F;font-size: 14px;">微信扫一扫</p>
			</div>
			<div class="sideBarLine"></div>
			<div class="sideBarTime">
				<img src="http://img.anxuan360.com/FhoCnHsf7eCrOIPvrnt9cvXpPMQj">
				<p>24小时服务</p>
			</div>
			<div class="sideBarLine" :class="!sideBarTotop_show?'noshow':'show'"></div>
			<div class="sideBarTotop" :class="!sideBarTotop_show?'noshow':'show'" @click="gotop">
				<img src="http://img.anxuan360.com/FuxnbUVKdGR17NHtccdvn0FU78Y_">
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'app',
		metaInfo: {
			title: '浙江安宣-信息化监管和食品安全追溯平台，重要产品追溯平台以及农贸O2O电商平台，国家高新技术企业，全栈追溯技术服务商。',
			meta: [{
					name: 'renderer',
					content: 'http://www.ax168.com'
				},
				{
					name: 'keywords',
					content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
				},
				{
					name: 'description',
					content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
				}
			],
			link: [{ // set link
				rel: 'shortcut icon',
				href: 'http://img.anxuan360.com/Fg9S6vA7COnIhL_dFQEgCUgHSgCl'
			}]
		},
		data() {
			return {
				header_show: true,
				footer_show: true,
				footer1_show: false,
				footer2_show: true,
				sideBarTotop_show: false,
				toastShow: false,
				toastText: '',
				select: '/',
				nav: [{
						name: '首页',
						isactive: 'active',
						path: '/',
						href: 'http://www.ax168.com/'
					}, {
						name: '产品服务',
						isactive: '',
						path: '/product',
						href: 'http://www.ax168.com/product'
					}, 
					// {
					// 	name: '典型案例',
					// 	isactive: '',
					// 	path: '/news',
					// 	href: 'http://www.ax168.com/news'
					// }, 
					{
						name: '智慧农贸',
						isactive: '',
						path: '/publicity',
						href: 'http://www.ax168.com/publicity'
					},
					{
						name: '数字农业',
						isactive: '',
						path: '/retrospect',
						href: 'http://www.ax168.com/retrospect'
					},
					{
						name: '产品追溯',
						isactive: '',
						path: '/zycpzs',
						href: 'http://www.ax168.com/zycpzs'
					},
					{
						name: '数字菜场',
						isactive: '',
						path: '/elmmarket',
						//						href: 'http://www.ax168.com/retrospect'
						href: 'http://www.ax168.com/elmmarket'
					},
					{
						name: '阳光餐饮',
						isactive: '',
						path: '/cyqy',
						href: 'http://www.ax168.com/cyqy'
					},
					{
						name: '阳光食堂',
						isactive: '',
						path: '/ygst',
						href: 'http://www.ax168.com/ygst'
					},

					{
						name: '金融服务',
						isactive: '',
						path: '/market',
						href: 'http://www.ax168.com/market'
					}, {
						name: '渠道合作',
						isactive: '',
						path: '/agent',
						href: 'http://www.ax168.com/agent'
					}, {
						name: '关于我们',
						isactive: '',
						path: '/about',
						href: 'http://www.ax168.com/about'
					}
				],
				chanpinNav: [{
					name: '食品追溯系统',
					isactive: 'active',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=0'
				}, {
					name: '食品检测系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=1'
				}, {
					name: '市场运营系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=2'
				}, {
					name: '商家管理系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=3'
				}, {
					name: '会员营销系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=4'
				}, {
					name: '网上菜场系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=5'
				}, {
					name: '市场招商系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=6'
				}, {
					name: '电子结算系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=7'
				}, {
					name: '智能巡查系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=8'
				}, {
					name: '数据展示系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=9'
				}, {
					name: '智慧农场系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=10'
				}, {
					name: '智慧禽畜系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=11'
				}, {
					name: '智慧水产系统',
					isactive: '',
					path: '/system',
					href: 'http://www.ax168.com/system?activeIndex=12'
				}],
         ICP_text:'浙ICP备15019864号-1',
      ICP:{
        "http://localhost:8081":"测试",
        "http://www.ax168.com":"浙ICP备15019864号-4",
        "http://www.anxuan360.com":"浙ICP备15019864号-1",
        "http://www.axnm168.com":"浙ICP备15019864号-5",
        "http://www.aswnm.com":"浙ICP备15019864号-7",
        "http://www.axny168.com":"浙ICP备15019864号-6"
      },
			}
		},
		    created: function() {
            let keys = Object.keys(this.ICP)
    let findIndex=  keys.findIndex(key=>{
       return  key.includes(window.location.host)
    })
    this.ICP_text =findIndex!=-1? this.ICP[keys[findIndex]]:this.ICP_text
      document.documentElement.style.fontSize = 16 + "px"
      },
		mounted() {

			//判断选中的路由
			this.select = this.$route.path;
			console.log(this.select)
			for(var i = 0; i < this.nav.length; i++) {
				if(this.select == this.nav[i].path) {
					this.nav[i].isactive = 'active'
				} else {
					this.nav[i].isactive = ''
				}
				if(this.select == '/system') {
					this.nav[1].isactive = 'active'
				}
				if(this.$route.name == 'marketC') {
					this.nav[2].isactive = 'active'
				}
				if(this.select == '/retrospect/') {
					this.nav[4].isactive = 'active'
				}
				if(this.select == '/zycpzs/') {
					this.nav[5].isactive = 'active'
				}
				if(this.select == '/ygst/') {
					this.nav[8].isactive = 'active'
				}
				if(this.select == '/publicity/') {
					this.nav[3].isactive = 'active'
				}
			}
//			if(this.select !== '/publicity') {
//				//刷新页面返回顶部
//				window.onbeforeunload = function() {
//					document.documentElement.scrollTop = 0; //ie下
//					document.body.scrollTop = 0; //非ie
//				}
//			}
			// 页面滚动监听
			let scrollTop = 0
			window.onscroll = () => {
				scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				scrollTop > 50 ? this.sideBarTotop_show = true : this.sideBarTotop_show = false;
			}
		},
		methods: {
      handNavGx(){
        window.open("http://beian.miit.gov.cn/", '_blank')
      },
			//是否显示头部
			header: function(bool) {
				this.header_show = bool
			},
			//是否显示底部
			footer: function(bool) {
				this.footer_show = bool
			},
			//			navfooter:function(bool){
			//			    alert(bool)
			//			},
			footer1: function(bool) {

				this.footer1_show = bool
			},
			footer2: function(bool) {

				this.footer2_show = bool
			},
			_isMobile() {
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				return flag;
			},
			// nav 点击跳转方法
			nav_active: function(index, path) {

				this.$router.push(path);
				this.select = this.$route.path;

				for(var i = 0; i < this.nav.length; i++) {
					if(i != index) {
						this.nav[i].isactive = '';
					} else {
						this.nav[i].isactive = 'active';
					}
				}
			},
			navTo: function(path, index) {

				for(var i = 0; i < this.nav.length; i++) {

					this.nav[i].isactive = '';

				}
				this.nav[1].isactive = 'active';
				this.$router.push({
					path: path,
					query: {
						activeIndex: index
					},
				})

				this.select = this.$route.path;
			},
			// toast弹窗
			toast(str) {
				let v = this
				v.toastText = str
				v.toastShow = true
				setTimeout(function() {
					v.toastShow = false
				}, 1500)
			},
			// 返回页面顶部
			gotop: function() {
				window.scrollTo(0, 0);
			}
		},
		watch: {
			$route: {
				handler(val, oldval) {
					console.log( val.name)
					if(val.name == 'retrospect' || val.name == 'elmmarket' || val.name == 'zycpzs' || val.name == 'ygst'|| val.name == 'cyqy') {
						this.footer_show = false
						this.footer1_show = false
						this.footer2_show = true
					} else {
						if(!this._isMobile()) {
							this.footer_show = true
							this.footer1_show = false
							this.footer2_show = true
						}
					}
				},
				// 深度观察监听
				deep: true
			}
		},
		components: {

		}
	}
</script>

<style>
	@import url(./css/app.css);
	@import './font/FZCQJW/FZCQJW';
	/*引入FZCQJW字体*/

	.company_infoDetail .company_infoDetail_text a {
		color: #6f747e;
	}

	.company_infoDetail .company_infoDetail_text a:hover {
		border-bottom: 1px solid #6f747e;
	}

	#app .sideBar.active {
		transform: scale(1.3);
		border-radius: 10px;
		overflow: hidden;
		right: 13px;
	}

	#app .show {
		display: block;
	}

	#app .noshow {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue